import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  estimate: () => __(translations.directoryLinkedRecource.estimate, 'Estimate'),
  order: () => __(translations.directoryLinkedRecource.order, 'Orders'),
  supplierOrder: () => __(translations.directoryLinkedRecource.supplierOrder, 'Supplier orders'),
  invoice: () => __(translations.directoryLinkedRecource.invoice, 'Invoice'),
  seeAll: () => __(translations.directoryLinkedRecource.seeAll, 'See all'),
  year: () => __(translations.directoryLinkedRecource.year, 'Year'),
  code: () => __(translations.directoryLinkedRecource.code, 'Code'),
  price: () => __(translations.directoryLinkedRecource.price, 'Price'),
  quantity: () => __(translations.directoryLinkedRecource.quantity, 'Quantity'),
  status: () => __(translations.directoryLinkedRecource.status, 'Status'),
  sales: () => __(translations.directoryLinkedRecource.sales, 'Nb of sales'),
  turnover: () => __(translations.directoryLinkedRecource.turnover, 'Turnover'),
  supplierTurnover: () => __(translations.directoryLinkedRecource.supplierTurnover, 'Supplier turnover'),
  supplierProductCount: () => __(translations.directoryLinkedRecource.supplierProductCount, 'Nb of products'),
  total: () => __(translations.directoryLinkedRecource.total, 'Total :'),
};
